module.exports = __webpack_public_path__ + "static/Muli-SemiBold.92860f9d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-SemiBold.ttf
// module id = 340
// module chunks = 114276838955818